import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowLeft, FileText } from "lucide-react";
import { PageContent } from "@/pages/ManagedPage";

export function PortalPages() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/pages/nav").then((r) => setItems((r.data.items || []).filter((p) => p.nav_section === "candidate_resources"))).catch(() => {}); }, []);
  if (open) return (
    <div data-testid="portal-page-view">
      <button onClick={() => setOpen(null)} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#006090] mb-4" data-testid="portal-page-back"><ArrowLeft className="w-4 h-4" />Back to Resources</button>
      <PageContent slug={open} />
    </div>);
  if (!items.length) return null;
  return (
    <div className="mt-8" data-testid="portal-pages">
      <h2 className="font-semibold text-slate-900 mb-3">More Resources</h2>
      <div className="grid sm:grid-cols-2 gap-3">
        {items.map((p) => (
          <button key={p.slug} onClick={() => setOpen(p.slug)} data-testid={`portal-page-${p.slug}`}
            className="flex items-center gap-3 text-left rounded-xl border border-slate-200 bg-white p-4 hover:border-[#006090]/40 hover:shadow-sm transition-shadow">
            <FileText className="w-5 h-5 text-[#006090] shrink-0" /><span className="font-medium text-slate-800">{p.title}</span></button>))}
      </div>
    </div>);
}
